import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SideNavParentViewComponent } from './components/side-nav/side-nav-parent-view.component';
import { RegisterComponent } from './components/register/register.component';
import { RegisterConfirmComponent } from './components/register-confirm/register-confirm.component';
import { SigninComponent } from './components/signin/signin.component';
import { StudentProfileViewComponent } from './components/student-profile/student-profile-view.component';
import { SigninRedirectCallbackComponent } from './components/signin-redirect-callback/signin-redirect-callback.component';
import { SignoutRedirectCallbackComponent } from './components/signout-redirect-callback/signout-redirect-callback.component';
import { SilentRefreshCallbackComponent } from './components/silent-refresh-redirect-callback/silent-refresh-redirect-callback.component';
import { NoEmailFoundComponent } from './components/no-email-found/no-email-found.component';
import { YouthWorkerProfileViewComponent } from './components/youth-worker-profile-view/youth-worker-profile-view.component';
import { ChatViewComponent } from './components/chat/chat-view/chat-view.component';
import { FeedViewComponent } from './components/feed/feed-view/feed-view.component';
import { GoalsComponent } from './components/goals/goals-view/goals.component';

import { HomeComponent } from './pathways-ui/components/home/home.component';
import { CompletedConsentComponent } from './pathways-ui/components/completed-consent/completed-consent.component';
import { EndOfWorldComponent } from './pathways-ui/components/end-of-world/end-of-world.component';


const routes: Routes = [
    {
        path: '',
        component: HomeComponent,
        data: {
            appName: 'Student Portal',
        },
    },
    {
        path: 'home',
        component: HomeComponent,
        data: {
            appName: 'Student Portal',
        },
    },
    { path: 'signin-callback', component: SigninRedirectCallbackComponent },
    { path: 'signout-callback', component: SignoutRedirectCallbackComponent },
    {
        path: 'silent-refresh-callback',
        component: SilentRefreshCallbackComponent,
    },
    {
        path: 'register',
        component: SideNavParentViewComponent,
        children: [{ path: 'confirm', component: RegisterConfirmComponent }],
        title: "Registration"
    },
    {
        path: 'register/:id',
        component: RegisterComponent,
    },
    {
        path: 'profile',
        component: SideNavParentViewComponent,
        children: [{ path: '', component: StudentProfileViewComponent }],
        title: "My Profile"
    },
    {
        path: 'myyouthworker',
        component: SideNavParentViewComponent,
        children: [{ path: '', component: YouthWorkerProfileViewComponent }],
        title: "My Youth Worker"
    },
    {
        path: 'messaging',
        component: SideNavParentViewComponent,
        children: [{ path: '', component: ChatViewComponent }],
        title: "Messaging"
    },
    {
        path: 'feed',
        component: SideNavParentViewComponent,
        children: [{ path: '', component: FeedViewComponent }],
        title: "Feed"
    },
    {
        path: 'goals',
        component: SideNavParentViewComponent,
        children: [{ path: '', component: GoalsComponent }],
        title: "Goals"
    },
    {
        path: 'signin',
        component: SigninComponent,
        title: "Login"
    },
    {
        path: 'no-email',
        component: NoEmailFoundComponent,
        title: "No Email Found"
    },
    {
        path: 'consent-completed',
        component: CompletedConsentComponent,
    },
    {
        path: 'error',
        component: EndOfWorldComponent,
        title: "Error"
    },
    { path: '**', component: EndOfWorldComponent },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
